/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { MutationHookOptions } from '@apollo/client';
import { loggedInVar } from '@graphql/cache';
import {
  CustomerDocument,
  LoginMutation,
  LoginMutationVariables,
  useLoginMutation,
} from '@sdk/core';
import { writeToCookies } from '@utils/cookies';

import { AuthCookieExpiration, StorageTokens } from '@/lib/constants';

/**
 * Wrapper for auto-generated useLoginMutation to globally handle cache / storage when logging in.
 */
const useLogin = (opts: MutationHookOptions<LoginMutation, LoginMutationVariables> = {}) =>
  useLoginMutation({
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: CustomerDocument,
      },
    ],
    update: (cache, { data }) => {
      const {
        login: { token, refreshToken },
      } = data;

      writeToCookies(StorageTokens.TOKEN, token, {
        expires: AuthCookieExpiration,
      });
      writeToCookies(StorageTokens.REFRESH_TOKEN, refreshToken, {
        expires: AuthCookieExpiration,
      });

      loggedInVar(true);
    },
    ...opts,
  });

export default useLogin;
